import loadable from '@loadable/component';

export const MapLoadable = loadable(() => import('./MapContainer'));
